<template>
<section>

    <v-footer
      v-bind="localAttrs"
      :padless="true"
    >
      <v-card
        flat
        tile
        width="100%"
        class=" text-center"
        
      >
        <v-card-text class="white--text" style="background-color: #242424" >

            <v-row justify="center" dense>
              <v-col align="center" cols="12" sm="12" md="6" lg="4">
                <font-awesome-icon class="awesomeBig" :icon="['fas', 'map-marker-alt']" />
                  <div>
                    <a href="https://www.google.com/maps/search/parking+barcelona+port/@41.3575236,2.1804921,13.78z">Terminal E, Moll Adossat 08039 Barcelona</a>
                  </div>
              </v-col>

              <v-col align="center" cols="12" sm="12" md="6" lg="4">
                <font-awesome-icon class="awesomeBig" :icon="['fas', 'envelope']" />
                <div>
                  <a href="mailto:parkingbarcelonaport@es.costa.it">parkingbarcelonaport@es.costa.it</a>
                </div>
              </v-col>

              <v-col align="center" cols="12" sm="12" md="6" lg="4">
                <font-awesome-icon class="awesomeBig" :icon="['fas', 'clock']" />
                <div>{{ $t('horario') }}</div>
              </v-col>
            </v-row>

        </v-card-text>

        <v-card-text class="white--text" style="background-color: #212121">
          <v-row justify="center" dense>

            <v-col cols="12" sm="12" md="6">
              <router-link to="/zbe" class="mr-2">
                <span style="white-space:nowrap;">
                  <v-img class_="ml-2" style="vertical-align: middle; display: inline-block" src="@/assets/zbe.png" width="80" height="40" contain></v-img>
                  {{ $t('servicioZbe') }}
                </span>
              </router-link>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-img class_="ml-2" style="vertical-align: middle; display: inline-block" src="@/assets/crucero.png" width="80" height="40" contain></v-img>
              <a href="http://www.portdebarcelona.cat/es/web/Port-del-Ciudada/cruceros">{{ $t('listadoCruceros') }}</a>
            </v-col>

          </v-row>
        </v-card-text>

        <v-card-text class="white--text" style="background-color: #191919">
          <v-row justify="center" dense>

             <v-col>
                <router-link :to="{ name: 'aviso_legal', params: {tipoPagina: 0 } }" class="mr-2">
                  <span style="white-space:nowrap;">{{ $t('avisolegal') }}</span>
                </router-link> 
              </v-col>
              <v-col>
                <router-link 
                  :to="{ name: 'aviso_legal', params: {tipoPagina: 1 } }"
                  style="margin-left: 5px; margin-right: 5px;" class="mx-2_">
                  <span style="white-space:nowrap;">{{ $t('politicaDevolucion') }}</span>
                </router-link>
              </v-col>
              <v-col>

                <router-link 
                  :to="{ name: 'aviso_legal', params: {tipoPagina: 2 } }"
                  style="margin-left: 5px; margin-right: 5px;" class="mx-2_">
                  <span style="white-space:nowrap;">{{ $t('politicaprivacidad') }}</span>
                </router-link>


              
            </v-col>

          </v-row>
        </v-card-text>

        <v-card-text class="white--text" style="background-color: #101010">
          <v-row justify="center" dense>

            <v-col cols="12" sm="12" md="6">
              <div class="ml-6">
                <span style="white-space:nowrap;">
                  <font-awesome-icon class="awesome" :icon="['fas', 'lock']" /> {{ $t('pagoseguro') }}
                  <v-img class="ml-2" style="vertical-align: middle; display: inline-block" src="@/assets/paycomet.png" width="100" height="40" contain></v-img>
                </span>
              </div>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <div class="mr-6">
                <span class="ml-1" style="white-space:nowrap;">
                  {{ $t('copyright') }}
                  <v-img class="ml-2" style="vertical-align: middle; display: inline-block" src="@/assets/equinsa.png" width="100" height="40" contain></v-img>
                </span>
              </div>
            </v-col>

          </v-row>
        </v-card-text>

      </v-card>
    </v-footer>

  </section> 
  


</template>


<style scoped>
.pie {
  font-size: 12px;
  color: white;
}

.borde {
  border-bottom: 1px solid #222222;
}

.awesome, .awesomeBig {
  color: rgb(76, 175, 241);
  margin-left: 5px;
  margin-right: 5px;
}

.awesomeBig {
  font-size: 25px;
}
</style>



<script>
export default {
  name: "PiePagina"
};
</script>
